(() => {
  const encodedAmpersand = '&amp;';
  const ignoredTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA']);
  const textAttributes = [
    'alt',
    'aria-description',
    'aria-label',
    'aria-valuetext',
    'data-collapsed-label',
    'data-expanded-label',
    'data-label',
    'placeholder',
    'title',
    'value'
  ];

  const normalizeValue = (value) => {
    let normalizedValue = value;

    while (normalizedValue.includes(encodedAmpersand)) {
      normalizedValue = normalizedValue.split(encodedAmpersand).join('&');
    }

    return normalizedValue;
  };

  const normalizeTextNode = (node) => {
    if (!node.nodeValue?.includes(encodedAmpersand) || ignoredTags.has(node.parentElement?.tagName)) return;

    node.nodeValue = normalizeValue(node.nodeValue);
  };

  const normalizeElement = (element) => {
    textAttributes.forEach((attribute) => {
      const value = element.getAttribute(attribute);

      if (value?.includes(encodedAmpersand)) {
        element.setAttribute(attribute, normalizeValue(value));
      }
    });
  };

  const normalizeTree = (root) => {
    if (root.nodeType === Node.TEXT_NODE) {
      normalizeTextNode(root);
      return;
    }

    if (![Node.ELEMENT_NODE, Node.DOCUMENT_FRAGMENT_NODE, Node.DOCUMENT_NODE].includes(root.nodeType)) return;
    if (root.nodeType === Node.ELEMENT_NODE && ignoredTags.has(root.tagName)) return;

    if (root.nodeType === Node.ELEMENT_NODE) normalizeElement(root);

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        normalizeTextNode(node);
      } else if (!ignoredTags.has(node.tagName)) {
        normalizeElement(node);
      }

      node = walker.nextNode();
    }
  };

  const init = () => {
    normalizeTree(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          normalizeTextNode(mutation.target);
        } else if (mutation.type === 'attributes') {
          normalizeElement(mutation.target);
        } else {
          mutation.addedNodes.forEach(normalizeTree);
        }
      });
    });

    observer.observe(document.body, {
      attributeFilter: textAttributes,
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
